import { UnidadMedidaService } from './../../../shared/services/unidad-medida.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalPedidoItemDto, MaterialDto, PedidoItemDto, SaveMaterialDto, UnidadMedidaDto, SearchUnidadMedidaRequest, MenuFuncionCodes } from '../../../../../src/app/shared/model';
import { MenuFuncionService } from '../../../../../src/app/shared/services';
import { MaterialesService } from '../../../../../src/app/shared/services/materiales.service';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';


@Component({
  selector: 'app-dialog-agregar-material',
  templateUrl: './dialog-agregar-material.component.html',
  styleUrls: ['./dialogModificarPedidoItem.component.scss']
})
export class DialogAgregarMaterialComponent implements OnInit {

  public buttonAcceptText: string;
  public buttonCancelText: string;

  isSearching: boolean = false;
  isUnidadMedidaSearching: boolean = false;
  isSaving: boolean = false;
  canCreateNewMaterial: boolean = false;
  isValidating: boolean = false;

  formGroupNuevoMaterial : FormGroup;
  pedidoItem: PedidoItemDto;
  item: MaterialDto;
  unidadMedidaList: UnidadMedidaDto[];

  constructor(
    private dialogRef: MatDialogRef<DialogAgregarMaterialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalPedidoItemDto,
    private menuService: MenuFuncionService,
    private materialService: MaterialesService,
    private sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    private unidadMedidaService: UnidadMedidaService,
  ) { }

  ngOnInit() {
    this.menuService.checkMenu(MenuFuncionCodes.MATERIAL_ADD).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canCreateNewMaterial = true;
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancelNuevoMaterial();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });

    this.loadView();

    this.buttonAcceptText = 'Guardar';
    this.buttonCancelText = 'Cancelar';
  }

  loadView() {
    this.buildFormNuevoMaterial();
    this.getUnidadMedida();
  }

  buildFormNuevoMaterial() {
    this.formGroupNuevoMaterial = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'UnidadMedidaMaterialId': [null, Validators.required],
      // 'TipoMaterialId': ['', Validators.required],
    });
  }

  getUnidadMedida() {
    var r = new SearchUnidadMedidaRequest(null, null, true, "Nombre", null, null, true);
    this.isUnidadMedidaSearching = true;

    this.unidadMedidaService.search(r).subscribe(data=> {
      this.isUnidadMedidaSearching = false;
      this.unidadMedidaList = data?.result;
    },
    (err: HttpErrorResponse)=>{
      this.isUnidadMedidaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onGuardarNuevoMaterial() {
    if (!this.formGroupNuevoMaterial.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveMaterialDto(null, null,null ,true);
    r =
    {
      ...this.formGroupNuevoMaterial.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        TipoMaterialId: this.data.TipoMaterialId
      }
    };

    this.isSaving = true;
    this.materialService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.dialogRef.close(data.Result);
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  getErrorNombre() {
    return this.formGroupNuevoMaterial.get('Nombre')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorUnidadMedidaMaterialId() {
    return this.formGroupNuevoMaterial.get('UnidadMedidaMaterialId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  onCancelNuevoMaterial() {
    this.dialogRef.close(null);
  }
}
